import React from 'react';
import { Card, Row, Col, Statistic, Spin } from 'antd';
import { DollarOutlined } from '@ant-design/icons';
import { useGetFinanceDashboardQuery } from '../../store/api/financeApi';

const FinanceDashboardPage: React.FC = () => {
  const { data, isLoading } = useGetFinanceDashboardQuery();

  return (
    <div style={{ padding: 24 }}>
      <Card
        title={
          <span>
            <DollarOutlined /> Финансовый дашборд
          </span>
        }
      >
        {isLoading && !data ? (
          <div style={{ textAlign: 'center', padding: 40 }}>
            <Spin />
          </div>
        ) : (
          <>
            <Row gutter={16} style={{ marginBottom: 16 }}>
              <Col xs={24} sm={12} md={6}>
                <Card>
                  <Statistic title="Доход" value={data?.revenue ?? 0} precision={2} />
                </Card>
              </Col>
              <Col xs={24} sm={12} md={6}>
                <Card>
                  <Statistic title="Расход" value={data?.expenses ?? 0} precision={2} />
                </Card>
              </Col>
              <Col xs={24} sm={12} md={6}>
                <Card>
                  <Statistic
                    title="Прибыль"
                    value={data?.profit ?? 0}
                    precision={2}
                    valueStyle={{
                      color: (data?.profit ?? 0) >= 0 ? '#3f8600' : '#cf1322'
                    }}
                  />
                </Card>
              </Col>
              <Col xs={24} sm={12} md={6}>
                <Card>
                  <Statistic title="Дебиторка" value={data?.receivables ?? 0} precision={2} />
                </Card>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col xs={24} sm={12} md={6}>
                <Card>
                  <Statistic title="Кредиторка" value={data?.payables ?? 0} precision={2} />
                </Card>
              </Col>
              <Col xs={24} sm={12} md={6}>
                <Card>
                  <Statistic
                    title="Просроченная дебиторка"
                    value={data?.overdueReceivables ?? 0}
                    precision={2}
                    valueStyle={{ color: '#cf1322' }}
                  />
                </Card>
              </Col>
              <Col xs={24} sm={12} md={6}>
                <Card>
                  <Statistic
                    title="Просроченная кредиторка"
                    value={data?.overduePayables ?? 0}
                    precision={2}
                    valueStyle={{ color: '#cf1322' }}
                  />
                </Card>
              </Col>
            </Row>
          </>
        )}
      </Card>
    </div>
  );
};

export default FinanceDashboardPage;

